export default "__VITE_ASSET__DqGrQ0ak__"